import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
}
)
export class AuthenticationService {
  loggedIn: boolean;
  tokenJson: any;
  token: string;
  ruoloUser: string;
  currentUser_display_name: string = '';

  constructor(public jwtHelper: JwtHelperService) {
  }

  public setToken(token: string) {
    localStorage.setItem('token', token);
  }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  public isExpired() {
    return this.jwtHelper.isTokenExpired();
  }

  public iatDate() {
    return (this.jwtHelper.decodeToken().iat * 1000);
  }

  validityTokenInHour:number = 24;
  public isExpiredToken() {
    const iatMillisecondi = this.iatDate();
    const oraAttuale = Date.now();

    // Calcoliamo la differenza in millisecondi
    const millisecondiTrascorsi = oraAttuale - iatMillisecondi;

    // 1 giorno in millisecondi = 24 * 60 * 60 * 1000 = 86400000
    const unGiornoInMs = this.validityTokenInHour * 60 * 60 * 1000;

    return (millisecondiTrascorsi >= unGiornoInMs);
    /*
    if (millisecondiTrascorsi >= unGiornoInMs) {
      console.log("Il token è scaduto (è passato più di un giorno)");
    } else {
      console.log("Il token è ancora valido (è passato meno di un giorno)");
    }*/
  }

  public isAuthenticated(): boolean {
    this.token = this.getToken();
    if (this.token !== null) {
      this.tokenJson = this.jwtHelper.decodeToken(this.token);
      this.ruoloUser = this.tokenJson.role;
      localStorage.setItem('role', this.ruoloUser);
      localStorage.setItem('submitter', this.tokenJson.sub);
    }
    return !this.jwtHelper.isTokenExpired(this.token);
  }

  infoLocalExist() {
    let res = true;
    if (localStorage.length == 0 || localStorage.getItem('role') == null || localStorage.getItem('token') == null) {
      res = false;
    }
    return res
  }

  signOut(): void {
    localStorage.clear();
  }

  public isSuperAdmin(): boolean {
    return this.ruoloUser.includes('ROLE_SUPER_ADMIN');
  }
}
